import clsx from 'clsx'

type TypingDotsProps = {
  numberOfDots?: number
  className?: string
}
export const TypingDots = ({numberOfDots = 3, className = ''}: TypingDotsProps) => {
  return (
    <div className={clsx('typing-dots', className)}>
      {new Array(numberOfDots).fill('').map((_, index) => (
        <span key={index} className='dot' style={{animationDelay: `${index * 0.2}s`}} />
      ))}
    </div>
  )
}
